module.exports = __webpack_public_path__ + "static/media/su_map_ack_2.1842d497.jpeg";